export const addRateOfReturnToSummaryArr=(accountLabel, subType, rateOfReturn, summaryArr) => {
    const indx = summaryArr.findIndex(elem => elem.accountLabel + elem.subType === accountLabel + subType);
    if (indx !== -1){
        summaryArr[indx] = {...summaryArr[indx], rateOfReturn: rateOfReturn};
    }
}

export default addRateOfReturnToSummaryArr;